import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ShipmentSearch from '../ShipmentSearch';
import { shipments as shipmentsApi } from '@afosto/fulfilment/api/Shipments';

const ShipmentFilter = ({ onChange, operator, settings, suggestions, value, ...props }) => {
  const [shipments, setShipments] = useState([]);
  const valueRef = useRef(value);

  useEffect(() => {
    valueRef.current = value;
  });

  useEffect(() => {
    const initialValue = valueRef.current;

    const fetchShipments = async () => {
      try {
        const promises = initialValue.map(shipmentId => shipmentsApi.viewShipment(shipmentId));
        const results = await Promise.all(promises);

        const formattedShipments = results.reduce((acc, result) => {
          const shipment = result?.data;

          if (shipment) {
            return [...acc, { ...shipment, label: shipment.number, value: shipment.id }];
          }

          return acc;
        }, []);

        setShipments(formattedShipments);
      } catch (err) {
        setShipments([]);
      }
    };

    if (initialValue && initialValue?.length > 0) {
      fetchShipments();
    }
  }, []);

  const handleChange = (ev, selectedShipments) => {
    setShipments(selectedShipments);

    if (onChange && typeof onChange === 'function') {
      onChange(
        ev,
        selectedShipments.map(selectedShipment => selectedShipment?.id),
      );
    }
  };

  return (
    <ShipmentSearch
      {...props}
      onChange={handleChange}
      value={shipments}
      multiple
      enableCreate={false}
      validateShipment={false}
    />
  );
};

ShipmentFilter.propTypes = {
  onChange: PropTypes.func,
  operator: PropTypes.string,
  settings: PropTypes.object,
  suggestions: PropTypes.array,
  value: PropTypes.array,
};

ShipmentFilter.defaultProps = {
  onChange: undefined,
  operator: undefined,
  settings: {},
  suggestions: [],
  value: [],
};

export default ShipmentFilter;
